/* ============
 * License Group Transformer
 * ============
 *
 * The transformer for the licenseGroup.
 */

import Transformer from './transformer';

export default class licenseGroupTransformer extends Transformer {

  static fetch(licenseGroup) {
    return {
      id: licenseGroup.id,
      licenseTypeId: licenseGroup.license_type_id,
      code: licenseGroup.code,
      name: licenseGroup.name,
      description: licenseGroup.description,
    };
  }

  static send(licenseGroup) {
    return {
      id: licenseGroup.id,
      name: licenseGroup.name,
      description: licenseGroup.description,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/licenseGroup.js